// extracted by mini-css-extract-plugin
export default {"ConfirmationPop":"RecipePop_ConfirmationPop__ktI4m","modalBody":"RecipePop_modalBody__r2D81"};